import IWithSiteLink from '@/data/dtos/IWithSiteLink';
import { SocialLinkDTO } from '@/data/dtos/SocialLinkDTO';
import { EventCategoryDTO } from '@/data/dtos/Events/EventCategoryDTO';
import { EventDTO } from '@/data/dtos/Events/EventDTO';
import { EventOrganizerDTO } from '@/data/dtos/Events/EventOrganizerDTO';
import { EventAssociationDTO } from '@/data/dtos/Events/EventAssociationDTO';
import { EventFullLanguageDTO } from '@/data/dtos/Events/EventFullLanguageDTO';
import Serializable from "@/data/dtos/Serializable";

export class EventInstructorDTO extends Serializable<EventInstructorDTO> implements IWithSiteLink {

	id: string;
	verified: boolean;
	featured: boolean;
	slug: string;
	name: string;
	nameWithPrefix: string;
	headline: string;
	currentPosition: string | null;
	currentLocationCountry: string;
	currentLocationCountryISO: string;
	bio: string;

	languages: EventFullLanguageDTO[];
	email: string | null;
	phone: string | null;
	avatar: string;

	social: SocialLinkDTO[] | null;
	categories: EventCategoryDTO[] | null;
	brands: EventOrganizerDTO[] | null;
	associations: EventAssociationDTO[] | null;
	events: EventDTO[] | null;

	siteLink: string;

	customButtonLabel: string | null;
	customButtonLink: string | null;

    constructor(data: Partial<EventInstructorDTO>) {
		super();

		this.id = data.id!;
		this.verified = data.verified!;
		this.featured = data.featured!;
		this.slug = data.slug!;
		this.name = data.name!;
		this.nameWithPrefix = data.nameWithPrefix!;
		this.headline = data.headline!;
		this.currentPosition = data.currentPosition || null;
		this.currentLocationCountry = data.currentLocationCountry!;
		this.currentLocationCountryISO = data.currentLocationCountryISO!;
		this.bio = data.bio!;

		this.customButtonLabel = data.customButtonLabel || null;
		this.customButtonLink = data.customButtonLink || null;

		this.languages = data.languages!;
		this.email = data.email || null;
		this.phone = data.phone || null;
		this.avatar = data.avatar!;
		this.social = data.social || null;
		this.categories = data.categories || null;
		this.brands = data.brands || null;
		this.associations = data.associations || null;
		this.events = data.events || null;
		this.siteLink = data.siteLink!;
	}

	public static fromArray(instructor: any, locale: string): EventInstructorDTO {
		return new EventInstructorDTO({
			...instructor,
			siteLink: `/expert/${instructor.slug}`,
			brands: instructor.brands?.length
				? instructor.brands.map((brand: EventOrganizerDTO) => ({
						...brand,
						siteLink: `/events/${brand.slug}`,
					}))
				: null,
			associations: instructor.associations?.length
				? instructor.associations.map((association: EventAssociationDTO) => ({
						...association,
						siteLink: `/events/${association.slug}`,
					}))
				: null,
			events: instructor.events?.length ? instructor.events.map((event: any) => EventDTO.fromArray(event, locale)) : null,
		});
	}
}
